<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" :max-width="600" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-text.pa-6
      div.d-flex.align-center
        v-icon(color="danger500" size="24") $yzi-alert-circle
        div.text-xl.font-medium.neutral700--text.ml-4 Alert: Insufficient credit
      div.text-md.neutral700--text.mt-4 {{ blast.method === 'sms' ? 'SMS' : blast.method === 'email' ? 'Email' : 'WhatsApp' }} deliverance for your
       span.font-semibold.mx-1 {{ offer.name }}
       | offer has been paused because of insufficient credit.
      div.text-md.neutral700--text.mt-2(v-if="preset === 'birthday'") Delivery for this month can’t be deployed
      div.text-md.neutral700--text.mt-2(v-if="preset === 'reactivation'") Last delivery on {{ pausedSchedule.tasked_at | displayDate }} can’t be deployed
      div.text-md.neutral700--text.mt-4 This is the cost needed to resolve the message delivery:
      div.text-xl.font-semibold.neutral700--text.mt-2 {{ totalCost | displayPrice($currency) }}
      div.text-sm.neutral700--text.mt-4 Your balance:
      credit-balance
      div.text-md.neutral700--text.mt-4(v-if="preset === 'birthday'") After reloading your credits, you can click resolve to resend messages to all recipients for this month.
      div.text-md.neutral700--text.mt-4(v-if="preset === 'reactivation'") After reloading your credits, you can resolve the paused delivery status.
        
    v-divider
    v-card-actions.pb-4.pt-3.px-6
      y-button.mr-4(:label="$t('cancel')" underline size="md" button-class="px-0" @click="closeDialog")
      v-spacer
      y-button(label="Resolve" size="md" :disabled="disableResend" :loading="isLoading" @click="resendSchedule")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CreditBalance from '@/components/clinic/marketing/CreditBalance.vue'

export default {
  components: { CreditBalance },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    preset: {
      type: String,
      default: null
    },
    blast: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    pausedSchedule () {
      return this.blast.schedules.find(f => f.status === 'paused')
    },
    totalCost () {
      let cost = 0
      let selected = this.pausedSchedule
      if (selected.metadata.required_credit) {
        cost = selected.metadata.required_credit
      }
      return cost
    },
    creditBalance() {
      return this.company.prepaid_credits
    },
    disableResend () {
      let disable = false
      if (this.totalCost > this.creditBalance) disable = true
      return disable
    },
  },
  methods: {
    ...mapActions(['showMessage']),
    async resendSchedule () {
      this.isLoading = true
      this.$axios.post(`/marketing/${this.company.slug}/blasts/${this.blast.id}/resend`, { schedule: this.pausedSchedule.id })
        .then(() => {
          this.$emit('updated')
          this.closeDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
        })
        .finally(() => {  
          this.isLoading = false
        })
    },
    closeDialog () {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
</style>